<template>
	<div v-bind:class="['input', { 'error': error }]">
		<label>Email Address</label>
		<input
			class="email_input"
			ref="input"
			name="email"
			type="email"
			:value="value"
			autofocus="true"
			v-on:input="change"
			v-on:keydown.13="enter">

		<label
			v-if="error"
			class="error">
			{{ error }}
		</label>
		<label
			v-if="secondary"
			class="forgot"
			@click="altNext">
			{{ secondary }}
		</label>
	</div>
</template>

<script>
import AuthInput from '.'

export default {
	name: 'auth-email-input',
	extends: AuthInput,

	data() {
		return {
			type: 'email',
			email: this.value
		}
	}
}
</script>

<style scoped lang="scss">
@import "style.scss";

.email_input {
	border-color: black !important;
	background: white;
}
</style>
